import { Component, OnInit } from '@angular/core';
import { ReportsRepositoryService } from '../../services/reports-repository.service';

@Component({
  selector: 'app-asc-code-reports',
  templateUrl: './asc-code-reports.component.html',
  styleUrls: ['./asc-code-reports.component.scss']
})
export class AscCodeReportsComponent implements OnInit {

  constructor(private reportsRepository: ReportsRepositoryService) { }

  ngOnInit(): void {
  }

}
